// Cliente HTTP unico de TEGO Cloud.
//
// Todo pasa por aqui: adjunta el token, arma las cabeceras, interpreta la
// respuesta y normaliza los errores. La API vive en el mismo origen bajo
// /api (nginx en produccion, proxy de Vite en desarrollo), asi que no hay
// que configurar URLs por entorno.

// ====================================================================
// LA CREDENCIAL YA NO VIVE AQUÍ · hallazgo A-4 (deuda T-d)
// ====================================================================
// Vivía en `localStorage`, que NO se borra al cerrar el navegador: una
// credencial robada seguía ahí mañana. `ANTES-DE-SALIR-A-INTERNET.md`
// lo declaraba requisito antes de salir de la red local.
//
// Ahora la sesión es una cookie `HttpOnly` que pone el servidor y que
// ESTE MISMO ARCHIVO NO PUEDE LEER. Es el punto entero: si el nuestro
// no la lee, el de un atacante tampoco.
//
// Y ya no hace falta adjuntar nada: el navegador manda la cookie sola
// en cada petición al mismo origen, que es donde vive `/api`.
const CLAVE_TOKEN = 'tego_token';

// SOLO DICE «CREO QUE HAY SESIÓN». No es una credencial y no abre nada:
// es lo que necesita la pantalla para saber si pintar la aplicación o
// la puerta, y para no mandar un «salir» de quien ya está fuera.
//
// El guardián sigue siendo el servidor. Si este valor mintiera, la
// primera petición devolvería 401 y la sesión se cerraría sola.
const CLAVE_HAY_SESION = 'tego_hay_sesion';

export function marcarSesion(activa) {
  try {
    if (activa) localStorage.setItem(CLAVE_HAY_SESION, '1');
    else localStorage.removeItem(CLAVE_HAY_SESION);
    // LA MUDANZA, y hay que hacerla aquí. Quien ya usaba TEGO tiene un
    // token de verdad guardado de antes de este cambio, y seguiría ahí
    // para siempre: la credencial que se venía a quitar del disco se
    // habría quedado en el disco de todo el mundo que ya estaba dentro.
    localStorage.removeItem(CLAVE_TOKEN);
  } catch { /* modo privado */ }
}

export function haySesion() {
  try {
    return localStorage.getItem(CLAVE_HAY_SESION) === '1';
  } catch {
    return false;
  }
}

// SE QUEDA, Y DEVUELVE NULO SIEMPRE. Hay llamadas sueltas en la
// pantalla que la usan para armar la cabecera a mano; devolver nulo
// hace que manden `Bearer null`, y el servidor trata eso como «no trae
// cabecera» y usa la cookie. Ver `_NO_SON_CREDENCIALES` en `deps.py`.
//
// Quitar la función las habría roto de golpe; dejarla mintiendo —
// devolviendo algo que parezca un token— habría sido peor.
export function leerToken() {
  return null;
}

// QUÉ PASA CUANDO EL SERVIDOR DICE QUE YA NO ESTÁS · deuda T-a.
//
// EL PROBLEMA QUE CIERRA. `procesar` convertía el 401 en un error con su
// código y lo lanzaba; cada pantalla lo enseñaba como un mensaje y ahí
// acababa. Nadie cerraba la sesión: el menú seguía completo, la pantalla
// seguía enseñando lo que ya había cargado, y quien estaba delante no se
// enteraba de que ya no estaba dentro hasta que intentaba hacer algo.
//
// El servidor no regalaba ningún dato —las 221 rutas contestan 401— pero
// lo que quedó en la pantalla de un almacén compartido sigue siendo
// información de la empresa, y quien llegue después la lee.
//
// SE AVISA EN UN SOLO SITIO, y no en cada pantalla, por lo mismo que el
// backend comprueba el rol en un solo embudo: una regla repartida por
// cuarenta sitios acaba con un sitio que se la saltó.
let alPerderLaSesion = null;

/** Lo registra `auth.jsx` al montarse. Uno solo, a propósito. */
export function avisarmeSiSePierdeLaSesion(fn) {
  alPerderLaSesion = fn;
}

// La puerta NO cuenta. Un 401 de `/auth/login` es «te equivocaste de
// contraseña», no «se te acabó la sesión»: avisar ahí mandaría a la
// pantalla de acceso a quien ya está en ella, borrándole lo que escribió.
// Entrar con llave de acceso (ESTABILIDAD D3) también es la puerta.
const ES_LA_PUERTA = /\/auth\/(login|login-pin|llave\/entrar|llave\/opciones)$/;

// Tope duro de la exportacion completa. No es una preferencia estetica:
// mas alla de esto el navegador arma un CSV de decenas de MB y la pestana
// se queda sin memoria a mitad, que para el usuario es indistinguible de
// que el sistema se colgo. Si se alcanza, la exportacion LO DICE.
export const TOPE_EXPORTACION = 20000;

// Recorre TODAS las paginas de una lista y las junta.
//
// EL PROBLEMA QUE RESUELVE. "Exportar" bajaba lo que habia en pantalla.
// Con una lista de 100 por pagina, quien tenia 340 productos recibia un
// archivo llamado `productos.csv` con 100 renglones y ninguna senal de
// que faltaran 240. Ese archivo acaba en el correo del contador.
//
// `construirRuta(limite, desplazamiento)` devuelve la ruta de cada pagina;
// `alAvanzar(cuantas)` sirve para que el boton diga por donde va.
export async function traerTodo(construirRuta, { porPagina = 500, alAvanzar } = {}) {
  const filas = [];
  let desplazamiento = 0;
  let total = null;

  for (;;) {
    const pagina = await fetch(
      `/api${construirRuta(porPagina, desplazamiento)}`, { headers: cabeceras() },
    );
    const datos = await procesar(pagina);
    if (total === null) {
      const cabecera = pagina.headers.get('X-Total');
      if (cabecera !== null) total = Number(cabecera);
    }
    filas.push(...datos);
    alAvanzar?.(filas.length, total);

    // Se para por lo que diga el servidor, no por lo que se supuso: una
    // pagina corta significa que ya no hay mas.
    if (datos.length < porPagina) break;
    if (filas.length >= TOPE_EXPORTACION) return { filas, total, completo: false };
    desplazamiento += porPagina;
  }
  return { filas, total, completo: true };
}

// Error con el mensaje que el backend ya devuelve en 'detalle' (nunca un
// stack trace: el backend no los expone).
export class ErrorApi extends Error {
  constructor(mensaje, status, extra = {}) {
    super(mensaje);
    this.status = status;
    // LO QUE EL SERVIDOR DICE ADEMÁS DEL TEXTO (19 sep 2026): en un
    // rechazo del alta pública, `codigo` (DATO_INVALIDO), `campo` (el
    // que está mal) y `paso` (en cuál del asistente vive). La pantalla
    // los usa para abrir el paso correcto y marcar el campo; quien no
    // los necesite sigue leyendo `message` como siempre.
    this.codigo = extra.codigo || null;
    this.campo = extra.campo || null;
    this.paso = extra.paso || null;
    // EL CONTRATO DE LA TERMINAL v2 (10 oct 2026, auditoría F1 H-4)
    // contesta `{detail: {codigo, mensaje, que_hacer, pantalla}, detalle}`.
    // `queHacer` es nuevo y opcional; `message` sigue siendo `detalle`.
    this.queHacer = extra.queHacer || null;
  }
}

async function procesar(respuesta) {
  const esJson = (respuesta.headers.get('content-type') || '').includes('application/json');
  const cuerpo = esJson ? await respuesta.json() : null;

  if (respuesta.status === 401 && !ES_LA_PUERTA.test(new URL(
    respuesta.url || '/', window.location.origin).pathname)) {
    // Se avisa ANTES de lanzar el error, para que la sesión se cierre
    // aunque la pantalla que llamó no atrape nada.
    alPerderLaSesion?.();
  }

  if (!respuesta.ok) {
    // El manejador de errores del backend responde {detalle, incidencia?}.
    // SIN `detalle` NO SE ENSEÑA UN CÓDIGO HTTP. «Error 502» no le dice
    // nada a nadie: pasa cuando el servidor no contestó siquiera con un
    // cuerpo —está reiniciando, o el proxy no lo alcanza— y eso sí se
    // puede explicar.
    // EL DETALLE PUEDE SER UN OBJETO, y hasta hoy eso se perdía. El alta
    // pública rechaza con `{detalle: {codigo, campo, paso, detalle}}` —el
    // texto va DENTRO— y aquí se leía `cuerpo.detalle` como si fuera
    // texto: no lo era, y la persona veía «No se pudo completar lo que
    // pediste» sin saber que el problema era su contraseña. El 19 de
    // septiembre de 2026 el dueño lo tomó por un 500 del servidor. El
    // servidor había dicho exactamente qué pasaba; esta línea lo tiraba.
    const estructurado = (cuerpo && cuerpo.detalle && typeof cuerpo.detalle === 'object')
      ? cuerpo.detalle : null;
    let detalle =
      (estructurado && typeof estructurado.detalle === 'string' && estructurado.detalle)
      || (cuerpo && typeof cuerpo.detalle === 'string' && cuerpo.detalle)
      || (cuerpo && typeof cuerpo.detail === 'string' && cuerpo.detail)
      || (respuesta.status === 429
        // El limitador de peticiones contesta sin `detalle` si el servidor
        // es de antes de hoy; aun así se dice qué pasó y qué hacer.
        ? 'Lo intentaste demasiadas veces seguidas desde esta conexión. '
          + 'Espera unos minutos y vuelve a intentarlo.'
        : respuesta.status >= 500
          ? 'El servidor no contestó. Puede que se esté reiniciando: espera '
            + 'unos segundos y vuelve a intentarlo. Si sigue igual, avisa a '
            + 'quien cuide el servidor.'
          : 'No se pudo completar lo que pediste, y el servidor no dijo por '
            + 'qué. Vuelve a intentarlo.');

    // LOS MOTIVOS POR CAMPO SE PERDIAN. El backend responde
    // `{detalle, errores:[{campo, motivo}]}` y aqui solo se leia
    // `detalle`, así que el usuario veía «Revisa los datos» sin saber
    // CUÁL — que es justo lo que necesita para arreglarlo. Se pegan al
    // mensaje: es mejor una frase larga que una inútil.
    if (Array.isArray(cuerpo?.errores) && cuerpo.errores.length) {
      detalle += ` ${cuerpo.errores
        .map((e) => `${e.campo ? `${e.campo}: ` : ''}${e.motivo}`)
        .join(' ')}`;
    }
    // EL NÚMERO DE INCIDENCIA SE PEGA AL MENSAJE, y hasta hoy se tiraba.
    // El servidor lo devuelve en cada 500 justamente para que una
    // persona pueda dárselo a quien la ayude — y el mensaje del servidor
    // lo nombra— pero aquí solo se leía `detalle`, así que el número no
    // llegaba nunca a la pantalla. Un mensaje que dice «dale este
    // número» sin enseñar ningún número es peor que no decirlo.
    if (cuerpo?.incidencia && !String(detalle).includes(cuerpo.incidencia)) {
      detalle += ` (número ${cuerpo.incidencia})`;
    }

    // ADITIVO (auditoría F1 H-4): cuando `detail` es un objeto (contrato
    // v2 §1.1) su `codigo` y su `que_hacer` viajan en el error. Sin esto
    // un 409 TOPE_DEL_PLAN se leía igual que un 409 YA_VINCULADA. El texto
    // (`message`) no cambia, y `detalle` objeto sigue mandando.
    const detalleV2 = (cuerpo && cuerpo.detail && typeof cuerpo.detail === 'object'
      && !Array.isArray(cuerpo.detail)) ? cuerpo.detail : null;
    const extra = {
      ...(detalleV2 ? { codigo: detalleV2.codigo, queHacer: detalleV2.que_hacer } : {}),
      ...(estructurado || {}),
    };
    throw new ErrorApi(
      typeof detalle === 'string' ? detalle
        : 'No se pudo completar lo que pediste. Vuelve a intentarlo.',
      respuesta.status,
      extra,
    );
  }
  return cuerpo;
}

// YA NO ADJUNTA NINGUNA CREDENCIAL · hallazgo A-4. La manda el
// navegador solo, en la cookie `HttpOnly`, porque `/api` vive en
// nuestro mismo origen. `fetch` envía las cookies de su propio origen
// por omisión (`credentials: 'same-origin'`), así que no hay nada que
// configurar — y si algún día se cambiara ese valor por omisión, la
// aplicación entera dejaría de entrar a la vez, que es un fallo
// ruidoso y no uno silencioso.
function cabeceras(extra = {}) {
  return { ...extra };
}

// LA RESPUESTA DE UNA PUERTA DE ACCESO · ESTABILIDAD D1 y corrección F4b.
// Si la contraseña fue buena y falta el código, el servidor lo dice con la
// cabecera `X-Tego-Paso` y aquí se convierte en `codigo = 'SEGUNDO_FACTOR'`,
// para que la pantalla abra ese paso en vez de volver a pedirlo todo. Una
// sola función para todas las puertas: el hueco de F4b vino justo de
// corregir una puerta y dejar las otras con la forma vieja.
async function trasLaPuerta(r) {
  if (r.status === 401 && r.headers.get('X-Tego-Paso') === 'segundo-factor') {
    const e = await procesar(r).catch((err) => err);
    e.codigo = 'SEGUNDO_FACTOR';
    throw e;
  }
  return procesar(r);
}

// UNA LECTURA QUE NO LLEGÓ AL SERVIDOR SE REINTENTA UNA VEZ · TODO-SIRVE F3,
// 30 sep 2026. El censo de fachadas de la 3.15.176 (y el del 29 sep) midió
// en Personal, con la dueña a 1366 px, que al abrir la pantalla el
// expediente y las tarjetas de una persona salían en error con «Failed to
// fetch»: la petición no llegó al servidor (el medidor no vio ninguna
// respuesta) y al volver a abrir la pantalla ya cargaban. Es un tropiezo de
// red de un instante, y la persona no tiene por qué pagarlo con una tarjeta
// roja. Solo se reintenta la LECTURA (GET, que no cambia nada), una sola
// vez, tras una pausa corta, y nunca si el navegador ya sabe que no hay red
// ni si quien pidió la cortó a propósito. Una respuesta del servidor —un
// 4xx o un 5xx— no se reintenta: eso no es un tropiezo, es una respuesta.
export const PAUSA_REINTENTO_LECTURA_MS = 350;
async function leerConUnReintento(url, opciones) {
  // El reintento va por el MISMO `fetch` que falló: en el navegador es el
  // mismo, y en las pruebas (que lo cambian entre una y otra) evita que un
  // reintento tardío de una prueba caiga en el `fetch` de la siguiente.
  const pedir = globalThis.fetch;
  try {
    return await pedir(url, opciones);
  } catch (e) {
    if (e?.name === 'AbortError' || globalThis.navigator?.onLine === false) throw e;
    await new Promise((listo) => { setTimeout(listo, PAUSA_REINTENTO_LECTURA_MS); });
    return pedir(url, opciones);
  }
}

export const api = {
  // RENOVAR LA CREDENCIAL mientras se trabaja · deuda T-b.
  // Devuelve la respuesta del login —credencial nueva y los tres números
  // de la sesión— o lanza si ya no se puede.
  refrescar: () => fetch('/api/auth/refrescar', {
    method: 'POST', headers: cabeceras(),
  }).then(procesar),

  // Peticiones con cuerpo JSON.
  get: (ruta) => leerConUnReintento(`/api${ruta}`, { headers: cabeceras() }).then(procesar),

  // Igual que `get`, pero ademas devuelve CUANTOS registros hay en total.
  //
  // El total viaja en la cabecera `X-Total` y no en el cuerpo: las listas
  // ya devolvian un array y envolverlo habria roto a la vez las pantallas,
  // las exportaciones y medio centenar de pruebas. `total` es null cuando
  // el endpoint todavia no la manda, y quien lo reciba debe tratarlo como
  // "no se", nunca como cero.
  getConTotal: async (ruta) => {
    const r = await leerConUnReintento(`/api${ruta}`, { headers: cabeceras() });
    const filas = await procesar(r);
    const cabecera = r.headers.get('X-Total');
    return { filas, total: cabecera === null ? null : Number(cabecera) };
  },

  post: (ruta, datos) =>
    fetch(`/api${ruta}`, {
      method: 'POST',
      headers: cabeceras({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(datos ?? {}),
    }).then(procesar),

  // POST que devuelve un ARCHIVO, no JSON. `procesar` no sirve aqui:
  // espera un cuerpo JSON y con un .xlsx devolveria null en silencio.
  descargar: async (ruta, datos) => {
    const r = await fetch(`/api${ruta}`, {
      method: 'POST',
      headers: cabeceras({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(datos ?? {}),
    });

    if (!r.ok) {
      // El 413 no lo emite la aplicacion sino nginx, y responde con una
      // pagina HTML: sin este caso el usuario leeria "Error 413", que no
      // le dice ni que paso ni que hacer.
      if (r.status === 413) {
        throw new ErrorApi(
          'El listado pesa demasiado para generarlo de una vez. Acota el '
          + 'filtro (por ejemplo, por rango de fechas) y vuelve a exportar.',
          413,
        );
      }
      const esJson = (r.headers.get('content-type') || '').includes('application/json');
      const cuerpo = esJson ? await r.json() : null;
      throw new ErrorApi(cuerpo?.detalle || `Error ${r.status}`, r.status);
    }

    return r.blob();
  },

  // GET que devuelve un ARCHIVO. Hermano de `descargar`, que es POST.
  //
  // EXISTE PORQUE UN <a href> NO LLEVA EL TOKEN. La sesion viaja en la
  // cabecera Authorization, y un enlace normal la omite: la descarga
  // contestaria 401 y el navegador enseñaria una pagina en blanco sin
  // decir por que. Con esto se pide con la sesion puesta y se guarda el
  // blob.
  bajar: async (ruta) => {
    const r = await fetch(`/api${ruta}`, { headers: cabeceras() });
    if (!r.ok) {
      const esJson = (r.headers.get('content-type') || '').includes('application/json');
      const cuerpo = esJson ? await r.json() : null;
      throw new ErrorApi(cuerpo?.detalle || `Error ${r.status}`, r.status);
    }
    return r.blob();
  },

  put: (ruta, datos) =>
    fetch(`/api${ruta}`, {
      method: 'PUT',
      headers: cabeceras({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(datos ?? {}),
    }).then(procesar),

  patch: (ruta, datos) =>
    fetch(`/api${ruta}`, {
      method: 'PATCH',
      headers: cabeceras({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(datos ?? {}),
    }).then(procesar),

  del: (ruta, datos) =>
    fetch(`/api${ruta}`, {
      method: 'DELETE',
      headers: datos
        ? cabeceras({ 'Content-Type': 'application/json' })
        : cabeceras(),
      body: datos ? JSON.stringify(datos) : undefined,
    }).then(procesar),

  // Subida de archivos. NO se fija Content-Type a mano: el navegador tiene
  // que generarlo con el 'boundary' del multipart, y ponerlo nosotros
  // rompería el cuerpo de la peticion.
  subir: (ruta, archivo, campo = 'archivo') => {
    const cuerpo = new FormData();
    cuerpo.append(campo, archivo);
    return fetch(`/api${ruta}`, {
      method: 'POST',
      headers: cabeceras(),
      body: cuerpo,
    }).then(procesar);
  },

  // Subida de VARIOS campos a la vez: el Sello Digital son dos archivos y
  // una contraseña, y `subir` solo manda uno. Igual que allí, el
  // Content-Type lo pone el navegador.
  enviarFormulario: (ruta, cuerpo) =>
    fetch(`/api${ruta}`, {
      method: 'POST',
      headers: cabeceras(),
      body: cuerpo,
    }).then(procesar),

  // El login usa formulario OAuth2 (username/password), no JSON.
  // LA TERCERA PUERTA · Accesos Fase 1. JSON y no formulario: `/login`
  // usa `application/x-www-form-urlencoded` porque FastAPI lo exige para
  // `OAuth2PasswordRequestForm`, y esta no pasa por ahí.
  // `extra` OPCIONAL · corrección F4b: el código del segundo factor y
  // «recordar este aparato», igual que en `login`. Sin él, la llamada es
  // la de siempre.
  loginUsuario: (claveEmpresa, nombreUsuario, contrasena, extra = {}) =>
    fetch('/api/auth/login-usuario', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        clave_acceso: claveEmpresa,
        nombre_usuario: nombreUsuario,
        contrasena,
        ...(extra.codigo ? { codigo: extra.codigo } : {}),
        ...(extra.recordarAparato ? { recordar_aparato: true } : {}),
      }),
    }).then(trasLaPuerta),

  // `extra` ES OPCIONAL · ESTABILIDAD D1/D4. Sin él, la llamada es la de
  // siempre. Con él viajan el código del segundo factor y «no volver a
  // pedírmelo en este aparato». Si la contraseña fue buena y falta el
  // código, el servidor lo dice con la cabecera `X-Tego-Paso` y aquí se
  // convierte en `codigo = 'SEGUNDO_FACTOR'`, para que la pantalla abra ese
  // paso en vez de volver a pedirlo todo.
  login: (email, password, extra = {}) => {
    const cuerpo = new URLSearchParams();
    cuerpo.set('username', email);
    cuerpo.set('password', password);
    if (extra.codigo) cuerpo.set('codigo', extra.codigo);
    if (extra.recordarAparato) cuerpo.set('recordar_aparato', '1');
    return fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: cuerpo,
    }).then(trasLaPuerta);
  },
};
